import sal from 'sal.js';

sal();

document.addEventListener("DOMContentLoaded", () => {
    const contentSections = document.querySelectorAll('.with-content');

    contentSections.forEach(contentSection => {
        if (contentSection) {
            const headings = contentSection.querySelectorAll('h1, h2, h3, h4');

            headings.forEach(h => {
                if (!h.hasAttribute('data-sal')) {
                    h.setAttribute('data-sal', 'slide-up');
                    h.setAttribute('data-sal-delay', '100');
                    h.classList.add('animate-on-scroll');
                }
            });
        }
    });

    sal({
        once: true,
        animateClassName: 'is-visible',
    });
});
